const img = require('./wallet.svg'); export default img;